import React from 'react';
import ProjectSettingsModal from './ProjectSettingsModal';
import AccountSettingsModal from './AccountSettingsModal';

const SettingsModals: React.FC = () => {
  return (
    <>
      <ProjectSettingsModal />
      <AccountSettingsModal />
    </>
  );
};

export default SettingsModals;
